import { ROUTE_NAME } from '@/lib/constant';

export default [
    {
        path: '/shop/order_list_o/:activityId?',
        name: ROUTE_NAME.SHOP_ORDER_LIST_OLD,
        meta: {
            name: '订单列表',
            needBinding: true,
        },
        component: () => import(/* webpackChunkName: 'shop' */'@/pages/shop/orderList.vue'),
    },
    {
        path: '/shop/order_list/:activityId?',
        name: ROUTE_NAME.SHOP_ORDER_LIST,
        meta: {
            name: '订单列表',
            needBinding: true,
        },
        component: () => import(/* webpackChunkName: 'shop' */'@/pages/shop/newOrderList.vue'),
    },
    {
        path: '/shop/logistic/:serialNumber', // :serialNumber 订单编号
        name: ROUTE_NAME.SHOP_LOGISTIC,
        meta: {
            name: '物流信息',
            needBinding: true,
        },
        component: () => import(/* webpackChunkName: 'shop' */'@/pages/shop/logistic.vue'),
    },
    {
        path: '/shop/detail_o/:orderId', // :orderId 订单id
        name: ROUTE_NAME.SHOP_ORDER_DETAIL_O,
        meta: {
            name: '订单详情',
            needBinding: true,
        },
        component: () => import(/* webpackChunkName: 'shop' */'@/pages/shop/orderDetailO.vue'),
    },
    {
        path: '/shop/detail/:orderId', // :orderId 订单id
        name: ROUTE_NAME.SHOP_ORDER_DETAIL,
        meta: {
            name: '订单详情',
            needBinding: true,
        },
        component: () => import(/* webpackChunkName: 'shop' */'@/pages/shop/orderDetail.vue'),
    },
    {
        path: '/shop/new_detail/:orderId', // :orderId 订单id
        name: ROUTE_NAME.SHOP_ORDER_DETAIL_NEW,
        meta: {
            name: '订单详情',
            needBinding: true,
        },
        component: () => import(/* webpackChunkName: 'shop' */'@/pages/shop/newOrderDetail.vue'),
    },
];
